const DEFAULT_DRAG_THRESHOLD = 3;

export const updateDragHasMoved = (dragState, event, threshold = DEFAULT_DRAG_THRESHOLD) => {
  if (!dragState || !event) {
    return false;
  }
  const deltaClientX = event.clientX - dragState.startClientX;
  const deltaClientY = event.clientY - dragState.startClientY;
  if (Math.abs(deltaClientX) > threshold || Math.abs(deltaClientY) > threshold) {
    dragState.hasMoved = true;
  }
  return Boolean(dragState.hasMoved);
};

export const getDragDelta = (dragState, event, zoom = 1) => {
  const deltaClientX = event.clientX - dragState.startClientX;
  const deltaClientY = event.clientY - dragState.startClientY;
  const safeZoom = Math.max(Number(zoom) || 1, 0.1);

  return {
    deltaClientX,
    deltaClientY,
    deltaWorldX: deltaClientX / safeZoom,
    deltaWorldY: deltaClientY / safeZoom,
  };
};

export const translateLayout = (layout, deltaWorldX, deltaWorldY, minimums = {}) => ({
  ...layout,
  x: Math.round((Number(layout?.x) || 0) + deltaWorldX),
  y: Math.round((Number(layout?.y) || 0) + deltaWorldY),
  w: Math.max(
    minimums.w || 0,
    Math.round(Number(layout?.w) || 0),
  ),
  h: Math.max(
    minimums.h || 0,
    Math.round(Number(layout?.h) || 0),
  ),
});

export const resizeLayout = (layout, deltaWorldX, deltaWorldY, minimums = {}) => ({
  ...layout,
  w: Math.max(
    minimums.w || 0,
    Math.round((Number(layout?.w) || 0) + deltaWorldX),
  ),
  h: Math.max(
    minimums.h || 0,
    Math.round((Number(layout?.h) || 0) + deltaWorldY),
  ),
});

export const translatePoints = (points, deltaWorldX, deltaWorldY) =>
  (Array.isArray(points) ? points : []).map(point => ({
    ...point,
    x: Math.round((Number(point?.x) || 0) + deltaWorldX),
    y: Math.round((Number(point?.y) || 0) + deltaWorldY),
  }));
